import { useMatch } from '@tanstack/react-router';

import { MediaImagesDashboard as EstateMediaImagesDashboard } from '@/features/estate-media/components/media-images-dashboard';
import { MediaImagesDashboard as ProjectMediaImagesDashboard } from '@/features/project-media/components/media-images-dashboard';

export const MediaImages = () => {
  const estateMatch = useMatch({
    from: '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout',
    shouldThrow: false,
  });
  const projectMatch = useMatch({
    from: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout',
    shouldThrow: false,
  });

  if (estateMatch) {
    return <EstateMediaImagesDashboard />;
  }

  if (projectMatch) {
    return <ProjectMediaImagesDashboard />;
  }

  return null;
};
